import { apiFetch } from './client';

export const passwordResets = {
  request: (email: string) =>
    apiFetch<{ ok: true }>('/api/password-reset/request', { method: 'POST', body: JSON.stringify({ email }) }),
  lookup: (token: string) => apiFetch<{ expiresAt: string }>(`/api/password-reset/${token}`),
  complete: (token: string, password: string) =>
    apiFetch<{ ok: true }>(`/api/password-reset/${token}/complete`, { method: 'POST', body: JSON.stringify({ password }) }),
};
